export const updateTable = (target, project, key, version) => {
	const currentVersionNo = project[`${key}UpdatedTable`]?.versionNo;
	if (currentVersionNo === undefined || currentVersionNo !== version) {
		//console.log("project: ", project);
		console.log("Updating table with new version... ", project);
		const current = new Date();
		project[`${key}UpdatedTable`] = {
			versionNo: version,
			version: target,
			date: current
		};
	}
};

export const checkTableChange = (latestVersion, currentVersion) => {
	//CollumnCheck
	const currentHeaderMap = new Map(
		currentVersion.headers.map(h => [h.name, h])
	);
	const latestHeaderMap = new Map(latestVersion.headers.map(h => [h.name, h]));

	currentVersion.headers.forEach(header => {
		//Collumn Delete
		if (!latestHeaderMap.has(header.name)) {
			header._diff = { status: "deleted", userDecision: null };
		} else {
			//Collumn Edited
			if (latestHeaderMap.get(header.name).label !== header.label) {
				const originalLabel = header.label;
				header.label = latestHeaderMap.get(header.name).label;
				header._diff = {
					status: "edited",
					userDecision: null,
					originalData: originalLabel //Old label
				};
			} else {
				//Not Changed
				header._diff = { status: "normal", userDecision: "accept_new" };
			}
		}
	});
	latestVersion.headers.forEach((header, index) => {
		//Collumn Added
		if (!currentHeaderMap.has(header.name)) {
			header._diff = { status: "added", userDecision: null };
			currentVersion.headers.splice(index, 0, header);
		}
	});

	//RowCheck
	const currentRowMap = new Map(currentVersion.rows.map(r => [r.tasks, r]));
	const latestRowMap = new Map(latestVersion.rows.map(r => [r.tasks, r]));

	currentVersion.rows.forEach(row => {
		//Row Delete
		if (!latestRowMap.has(row.tasks)) {
			row._diff = { status: "deleted", userDecision: null };
		} else {
			let isEdited = false;
			const original = {};
			//Row Edited -- toolDescription
			if (latestRowMap.get(row.tasks).toolDescription !== row.toolDescription) {
				original.toolDescription = row.toolDescription;
				row.toolDescription = latestRowMap.get(row.tasks).toolDescription;
				/*row._diff = {
                              status: "edited",
                              userDecision: null,
                              originalData: originaltoolDescription //Old row
                        };*/
				isEdited = true;
			}
			//Row Edited -- toolLink
			if (!isSameLinks(latestRowMap.get(row.tasks).toolLink, row.toolLink)) {
				original.toolLink = [...row.toolLink];
				row.toolLink = latestRowMap.get(row.tasks).toolLink;
				isEdited = true;
			}
			if (isEdited) {
				row._diff = {
					status: "edited",
					userDecision: null,
					originalData: original //Old row
				};
			} else {
				row._diff = { status: "normal", userDecision: "accept_new" };
			}
		}
	});
	latestVersion.rows.forEach((row, index) => {
		//Row Added
		if (!currentRowMap.has(row.tasks)) {
			row._diff = { status: "added", userDecision: null };
			currentVersion.rows.splice(index, 0, row);
			currentRowMap.set(row.tasks, row); //update map
		}
	});
};

const isSameLinks = (arr1, arr2) =>
	arr1.length === arr2.length &&
	arr1.every(
		(item, i) => item.name === arr2[i].name && item.link === arr2[i].link
	);
